module.exports = __webpack_public_path__ + "static/media/jdrManoir_02_full.165e9f34.jpg";